const updates = [
  { date: '07-31', tag: '更新', title: '《奔跑吧》第十季第8期上线 — 全员泥潭大战笑翻全场', time: '2小时前' },
  { date: '07-31', tag: '更新', title: '《歌手2025》第十期歌单公布，帮帮唱环节阵容揭晓', time: '5小时前' },
  { date: '07-30', tag: '上线', title: '《密室大逃脱》第六季先导片来袭，全新密室场景首次曝光', time: '1天前' },
  { date: '07-30', tag: '更新', title: '《脱口秀大会》第五季半决赛 — 八强争夺最后决赛席位', time: '1天前' },
  { date: '07-29', tag: '上线', title: '《乘风破浪》第四季成团夜完整版上线，见证姐姐荣耀时刻', time: '2天前' },
  { date: '07-29', tag: '预告', title: '《披荆斩棘》新一季官宣阵容，多位实力派唱将加盟引期待', time: '2天前' },
  { date: '07-28', tag: '更新', title: '《极限挑战》第十季宝藏行特辑 — 全员沙漠探险全程高能', time: '3天前' },
  { date: '07-28', tag: '专题', title: '暑期综艺追看指南上线，一文带你了解今夏最值得追的综艺', time: '3天前' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-flashlight-line text-accent-400 text-xs"></i>
            <span className="text-xs text-accent-400 font-medium whitespace-nowrap">实时动态</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            最新更新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            综艺节目更新一手掌握，不错过任何精彩内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <a
              key={idx}
              href="#updates"
              onClick={(e) => e.preventDefault()}
              className="flex items-start gap-4 py-4 border-b border-background-300/20 last:border-0 group cursor-pointer hover:bg-background-100/50 px-3 -mx-3 rounded-lg transition-colors"
            >
              <div className="flex-shrink-0 w-14 text-center">
                <div className="text-xs font-medium text-foreground-400">{item.date}</div>
                <span className={`inline-block mt-1 px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                  item.tag === '更新' ? 'bg-primary-500/15 text-primary-400' :
                  item.tag === '上线' ? 'bg-accent-500/15 text-accent-400' :
                  item.tag === '预告' ? 'bg-secondary-500/15 text-secondary-400' :
                  'bg-background-300/40 text-foreground-400'
                }`}>
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm text-foreground-200 group-hover:text-primary-400 transition-colors font-medium leading-relaxed">
                  {item.title}
                </h3>
              </div>
              <div className="flex-shrink-0">
                <span className="text-xs text-foreground-600 whitespace-nowrap">{item.time}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}